export default "<a [routerLink]=\"['/']\">\n  <img [src]=\"logo\" alt=\"logo\" />\n</a>\n"